document.addEventListener('DOMContentLoaded', () => {
	const categoryButtons = document.querySelectorAll('[data-trigger="open-subcategories"]');

	categoryButtons.forEach(button => {
		button.addEventListener('click', () => {
			button.parentElement.classList.toggle('open');
		})

		const subcategories = button.parentElement.querySelectorAll('.subcategories');
		subcategories.forEach(subcategory => {
			subcategory.setAttribute('style', `--open-height: ${subcategory.scrollHeight}px;`);
		})

		window.addEventListener('resize', () => {
			subcategories.forEach(subcategory => {
				subcategory.setAttribute('style', `--open-height: auto;`);
				subcategory.setAttribute('style', `--open-height: ${subcategory.scrollHeight}px;`);
			})
		})
	})
})
